import {withTranslation as translate} from 'react-i18next';
import LanguageSwitch from './language-switch';

export default translate()(LanguageSwitch);
